import React from 'react';
const Button = ({value, className, onClick, type})=> {
    return (
        <button 
            type={type || "button"}
            className={"button " + (className || "")}
            value={value}
            onClick={onClick}
        >{value}</button>
    )
}
export default Button;